"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.warning.name.required': 'Fornisci almeno un nome avatar per continuare.',
};
